import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import {
    FAILURE_CREATE_NEW_VIDEO_ADMIN,
    FAILURE_EDIT_VIDEO_ADMIN,
    FAILURE_VIDEO_CATEGORIES_ADMIN,
    FAILURE_VIDEO_CATEGORIES_BY_TOPICID_ADMIN,
    FAILURE_VIDEO_RATINGS_ADMIN,
    FAILURE_VIDEO_TOPICS_ADMIN,
    REQUEST_CREATE_NEW_VIDEO_ADMIN,
    REQUEST_EDIT_VIDEO_ADMIN,
    REQUEST_VIDEO_CATEGORIES_ADMIN,
    REQUEST_VIDEO_CATEGORIES_BY_TOPICID_ADMIN,
    REQUEST_VIDEO_RATINGS_ADMIN,
    REQUEST_VIDEO_TOPICS_ADMIN,
    SUCCESS_CREATE_NEW_VIDEO_ADMIN,
    SUCCESS_EDIT_VIDEO_ADMIN,
    SUCCESS_VIDEO_CATEGORIES_ADMIN,
    SUCCESS_VIDEO_CATEGORIES_BY_TOPICID_ADMIN,
    SUCCESS_VIDEO_RATINGS_ADMIN,
    SUCCESS_VIDEO_TOPICS_ADMIN,
} from 'src/store/video-admin/actions';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';

/* Video Topics */
export function videoTopicsAdminReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VIDEO_TOPICS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_TOPICS_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_TOPICS_ADMIN:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Video Categories by topicId */
export function videoCategoriesByTopicIdAdminReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VIDEO_CATEGORIES_BY_TOPICID_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_CATEGORIES_BY_TOPICID_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_CATEGORIES_BY_TOPICID_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

/* Video Categories */
export function videoCategoriesAdminReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VIDEO_CATEGORIES_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_CATEGORIES_ADMIN: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_CATEGORIES_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function videoAdminReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CREATE_NEW_VIDEO_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_NEW_VIDEO_ADMIN:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_CREATE_NEW_VIDEO_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_EDIT_VIDEO_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EDIT_VIDEO_ADMIN:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_EDIT_VIDEO_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function videoRatingAdminReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_VIDEO_RATINGS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_RATINGS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_VIDEO_RATINGS_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
